import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Loader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/helpers/gpt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/home/_components/Content/LatestCatchupTilesDynamic/LatestCatchupTiles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/home/_components/Content/MoreItemsCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/home/_components/Content/OffersCarousal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/home/_components/Content/RecipeCarousal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/home/HomeDispatch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/home/SearchResults.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSliderWrapper","ShopSliderWrapper","CategorySliderWrapper","FreshBreadWrapper","FlyerOffersWrapper","MassoffersWrapper","TrendingProductsWrapper","SpecificDeals"] */ "/app/src/templates/home/Sliders/index.tsx");
